export default (value) => {
  const date = new Date(value)
  return date.toLocaleString(['en-US'], {month: 'short', day: '2-digit', yead: 'numeric', hour: '2-digit', minute: '2-digit'})
}



// WEBPACK FOOTER //
// ./src/filters/date.js